import { render } from "./LeituraVideos.vue?vue&type=template&id=26866828&scoped=true"
import script from "./LeituraVideos.vue?vue&type=script&lang=js"
export * from "./LeituraVideos.vue?vue&type=script&lang=js"

import "./LeituraVideos.vue?vue&type=style&index=0&id=26866828&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26866828"]])

export default __exports__